'use strict';
const XML_CHAR_MAP = {'<': '&lt;', '>': '&gt;', '&': '&amp;'};

module.exports = (text) => {
  let lines = text.split('\n');

  // Parse <> and & to ensure Word can open the file
  lines = lines.map(function (s) {
    const standardEncode = s.replace(/[<>&]/g, function (ch) { return XML_CHAR_MAP[ch]; });
    return standardEncode;
  });

  const pre = '<w:p><w:r><w:t>';
  const post = '</w:t></w:r></w:p>';
  const lineBreak = '<w:br/>';
  return pre + lines.join(lineBreak) + post;
};
